import { classNames } from "../../helpers/classNames";
import Button from "../../components/form/Button";
import Image from "../../components/elements/Image";
import GoogleLogo from "../../assets/image/google.svg";
import FacebookLogo from "../../assets/image/facebook.svg";
import AppleLogo from "../../assets/image/apple.svg";
import ImageSignin from "../../assets/image/image-signin.webp";
import ResetPasswordForm from "../../components/sections/front/Authentication/ResetPasswordForm";

const ResetPassword = () => {
  const socialData = [
    { _id: 1, name: "Google", image: GoogleLogo },
    { _id: 2, name: "Apple", image: AppleLogo },
    { _id: 3, name: "Facebook", image: FacebookLogo },
  ];

  return (
    <section className="relative flex items-center w-full min-h-screen py-16 sm:py-24 bg-white z-0">
      <div className="fixed top-0 left-0 w-full h-full z-[-1] flex">
        <Image src={ImageSignin} alt="" effect={"blur"} classes={"object-cover"} />
      </div>
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
        <div className="flex justify-center">
          <div className="relative py-8 md:py-12 px-8 md:px-12 bg-secondary/50 w-full max-w-lg rounded-6xl overflow-hidden border border-primary backdrop-blur-md">
            <div className="space-y-8">
              <div className="text-3xl text-primary font-semibold text-center">Reset Password</div>
              <ResetPasswordForm />
              <div className="overflow-hidden flex items-center justify-center relative">
                <span
                  className={classNames(
                    "relative inline-flex items-center justify-center bg-transparent text-white font-CanelaDeck",
                    "before:content-[''] before:absolute before:top-1/2 before:left-[calc(100%+12px)] before:w-[400px] before:border-t before:border-white/60 before:mt-px",
                    "after:content-[''] after:absolute after:top-1/2 after:right-[calc(100%+12px)] after:w-[400px] after:border-t after:border-white/60 after:mt-px"
                  )}>
                  or sign in with
                </span>
              </div>
              {socialData?.length > 0 && (
                <div className="flex items-center justify-center gap-4">
                  {socialData?.map((item, index) => (
                    <Button
                      key={index}
                      buttonClasses={"!bg-white/75 !rounded-xl !p-2 !h-auto !border-none hover:!bg-white/100"}
                      buttonLabel={
                        <div className="w-8 aspect-square overflow-hidden">
                          <Image src={item.image} alt="" effect={"blur"} classes={"object-contain"} />
                        </div>
                      }
                    />
                  ))}
                </div>
              )}
              <div className="text-center flex items-center justify-center text-sm gap-x-2 text-white">
                <span>Already have an account?</span>
                <Button
                  buttonLabel={"Sign In"}
                  buttonLabelClasses={"!text-sm !font-semibold"}
                  buttonClasses={"!h-auto !py-1 !px-0 !bg-transparent !text-primary"}
                  buttonHasLink
                  buttonLink={"/authentication"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
